import { useEffect } from 'react';

export const APP_NAME = 'FretBoard';

/**
 * Sets a unique `document.title` for the current route: "<Persian page name> | FretBoard" (FND-36).
 * Pages call it unconditionally at the top of the component.
 */
export function usePageTitle(pageName: string): void {
  useEffect(() => {
    document.title = `${pageName} | ${APP_NAME}`;
  }, [pageName]);
}
